<ng-container
    *ngrxLet="{
        dronePoint: dronePoint$,
        isOpened: isOpened$,
        arePhotoUrlsProcessing: arePhotoUrlsProcessing$
    } as vm"
>
    <dtm-ui-expandable-panel [hasHeaderSeparator]="false" [expanded]="vm.isOpened" *ngIf="vm.dronePoint">
        <div headerSlot class="header">
            <dtm-ui-icon name="dronepoint" />
            <h2>
                {{ vm.dronePoint.name }}
                <span>{{ "dtmMapCesium.dronePointDetails.dronePointLabel" | transloco }}</span>
            </h2>
        </div>
        <div class="content">
            <dtm-ui-label-value
                class="full-column"
                [label]="'dtmMapCesium.dronePointDetails.addressLabel' | transloco"
                [value]="vm.dronePoint.address"
            />
            <dtm-ui-label-value [label]="'dtmMapCesium.dronePointDetails.centerCoordinatesLabel' | transloco">
                {{ vm.dronePoint.centerPoint.latitude | invoke : displayLatitude }},
                {{ vm.dronePoint.centerPoint.longitude | invoke : displayLongitude }}
            </dtm-ui-label-value>
            <dtm-ui-label-value [label]="'dtmMapCesium.dronePointDetails.bordersCoordinatesLabel' | transloco">
                <ng-container *ngFor="let borderPoint of vm.dronePoint.borderPoints">
                    {{ borderPoint.latitude | invoke : displayLatitude }}, {{ borderPoint.longitude | invoke : displayLongitude }}
                    <br />
                </ng-container>
            </dtm-ui-label-value>
            <dtm-ui-label-value
                class="full-column"
                [label]="'dtmMapCesium.dronePointDetails.descriptionLabel' | transloco"
                [value]="vm.dronePoint.description"
            />
            <dtm-ui-label-value
                *ngIf="vm.dronePoint.photoUrls.length"
                class="full-column"
                [label]="'dtmMapCesium.dronePointDetails.photosLabel' | transloco"
            >
                <dtm-ui-loader-container [isShown]="vm.arePhotoUrlsProcessing">
                    <div class="photos">
                        <a
                            *ngFor="let photoUrl of vm.dronePoint.photoUrls; let index = index"
                            [href]="photoUrl"
                            target="_blank"
                            (click)="$event.preventDefault(); zoomPhoto(index)"
                        >
                            <img [dtmUiImgSecuredSrc]="photoUrl" (loadingChange)="setPhotoUrlProcessing($event, photoUrl)" alt="" />
                            <dtm-ui-icon name="zoom-in-line" />
                        </a>
                    </div>
                </dtm-ui-loader-container>
            </dtm-ui-label-value>
        </div>
    </dtm-ui-expandable-panel>
</ng-container>
